export const RECOMMENDATIONS_ACTION_TYPE_TO_PARAM_TYPES = {
    CAMPAIGN: 'CAMPAIGN_POJO_INPUT',
    CREATIVE: 'CREATIVE_POJO_INPUT',
};
